import {
  subscribeToVideoUpdates,
  unsubscribeFromVideoUpdates,
  cropVideo,
  setVideoTitle,
  setVideoDescription,
  generateThumbnail,
  removeVideo,
  removeAllVideos,
  uploadToMangomolo,
} from "./videos.js";

import {
  subscribeToGIFUpdates,
  unsubscribeFromGIFUpdates,
  generateGIF,
  removeGIF,
  removeAllGIFs
} from "./gifs";

import {
  subscribeToAudioUpdates,
  unsubscribeFromAudioUpdates,
  removeAudio,
  removeAllAudios,
  setAudioTitle,
  cropAudio,
  uploadToMangomoloAudio
} from "./audios.js";

export default {
  /** videos */
  subscribeToVideoUpdates,
  unsubscribeFromVideoUpdates,
  cropVideo,
  setVideoTitle,
  setVideoDescription,
  generateThumbnail,
  removeVideo,
  removeAllVideos,
  uploadToMangomolo,
  
  /** gifs */
  subscribeToGIFUpdates,
  unsubscribeFromGIFUpdates,
  generateGIF,
  removeGIF,
  removeAllGIFs,
  /** audios */
  subscribeToAudioUpdates,
  unsubscribeFromAudioUpdates,
  removeAudio,
  removeAllAudios,
  setAudioTitle,
  cropAudio,
  uploadToMangomoloAudio
}